import React, { useEffect, useState } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";

import ScrollToTop from "./utils/utils/ScrollToTop";
import CookiebotIntegration from "./utils/utils/CookiebotIntegration";
import "./utils/utils/i18n";
import Navbar from "./components/NavBar/Navbar";
import Home from "./pages/Home";
import AppPage from "./pages/AppPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactPage from "./pages/ContactPage";
import CareersPage from "./pages/CareersPage";
import ImprintPage from "./pages/ImprintPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import Footer from "./components/Footer/Footer";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isAuthenticated");
    if (isLoggedIn) {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    const storedAuth = localStorage.getItem("isAuthenticated");
    if (storedAuth === "true") setIsAuthenticated(true);
  }, []);

  const handleLogin = () => {
    if (username === "admin" && password === "onenizer@12321") {
      localStorage.setItem("isAuthenticated", true);
      setIsAuthenticated(true);
    } else {
      alert("Falscher Benutzername oder Passwort!");
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="login-modal">
        <div className="login-box">
          <h2>Login</h2>
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Benutzername"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Passwort"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <CookiebotIntegration />
      <ScrollToTop />
      <Navbar />

      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/app" component={AppPage} />
        <Route path="/aboutus" component={AboutUsPage} />
        <Route path="/contact" component={ContactPage} />
        <Route path="/careers" component={CareersPage} />
        <Route path="/imprint" component={ImprintPage} />
        <Route path="/privacypolicy" component={PrivacyPolicyPage} />
        <Route path="/termsofuse" component={TermsOfUsePage} />
      </Switch>

      <Footer />
    </Router>
  );
}

export default App;
